var _g, _path, _path2, _path3, _path4, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicalSignals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2135_2965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 40.9883C80 63.0797 62.0914 80.9883 40 80.9883C17.9086 80.9883 0 63.0797 0 40.9883C0 18.8969 17.9086 0.988281 40 0.988281C62.0914 0.988281 80 18.8969 80 40.9883Z",
    fill: "#3094B4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3343 29.5967H38.354V31.607H35.9023V44.4003H38.354V46.8194H39.3343V44.4003H41.786V31.607H39.3343V29.5967Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4578 27.9977H56.0071V25.9883H55.0258V27.9977H52.5742V42.7597H55.0258V45.1787H56.0071V42.7597H58.4578V27.9977Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9974 37.3057H30.0171V39.5203H27.5664V52.8056H30.0171V55.0203H30.9974V52.8056H33.45V39.5203H30.9974V37.3057ZM32.4697 40.5042V51.8217H28.5467V40.5042H32.4697Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6702 34.1895H46.6899V36.1989H44.2383V49.9771H46.6899V52.3961H47.6702V49.9771H50.1219V36.1989H47.6702V34.1895ZM49.1416 37.1837V48.9931H45.2186V37.1837H49.1416Z",
    fill: "#F9F9F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5957,
    y: 20.9883,
    width: 2.98901,
    height: 40,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.4492,
    y: 57.9883,
    width: 3,
    height: 39.8535,
    transform: "rotate(90 60.4492 57.9883)",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2135_2965",
    x: 0,
    y: 0.988281,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113333 0 0 0 0 0.432533 0 0 0 0 0.533333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2135_2965"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSignals);
export default __webpack_public_path__ + "static/media/technical-signals.2af7491990f6dc401a3a86ee4523f795.svg";
export { ForwardRef as ReactComponent };